import { StateWithUIState } from 'shared';

export const uiSelector = (state: StateWithUIState) => state.ui;
export const uiPropSelector = (propKey: string) => (state: StateWithUIState) => state.ui[propKey];
export const multiUiPropSelector = (propKeys: string[]) => (state: StateWithUIState) =>
  propKeys.reduce((acc, key) => {
    acc[key] = state.ui[key];
    return acc;
  }, {} as Record<string, any>);
